import {GetActiveMissionsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import React from 'react';
import {CoinsMissionBanner} from '../../../features/Coins/shared/CoinsMissionBanner';
import {MissionBannerType} from '../utils/missionType';

export const MissionBannerView: React.FC<
  GetActiveMissionsResponse & {
    className?: string;
    bannerType: MissionBannerType;
  }
> = ({className, bannerType, missionBanners}) => {
  const banner = missionBanners.find(
    banner => banner.missionBanner?.$case === bannerType,
  );

  switch (banner?.missionBanner?.$case) {
    case 'profileAndSecurityBanner':
      return (
        <CoinsMissionBanner
          className={className}
          {...banner.missionBanner.profileAndSecurityBanner}
        />
      );
    case 'settingsPageBanner':
      return (
        <CoinsMissionBanner
          className={className}
          {...banner.missionBanner.settingsPageBanner}
        />
      );
    default:
      return null;
  }
};
